import { EPartsLower } from '../../../types/fio';

export function getQueryIndex(currentPartFIO: EPartsLower) {
  switch (currentPartFIO) {
    case EPartsLower.Surname:
      return 0;

    case EPartsLower.Name:
      return 1;

    default:
      return 2;
  }
}
